import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { URLS } from '../../../../constants/environment.constants'
import { correctSlugPrefix } from '../../../../utils/link.utils'

export const getDynamicContent = (relatedResources: any, featuredResource: any, location: any) => {
  const dynamicContent = relatedResources.map((resource: any) => {
    resource.body = resource.teaserBody || resource.seoMetadata?.pageMetaDescription
    if (resource.slug) {
      resource.url1 = `${location?.origin || `${URLS.PROD}`}${correctSlugPrefix(resource.slug)}`
    }

    if (resource.__typename === ModuleNames.PAGE_RESOURCE_DEMO) {
      resource.title = resource.hero?.headline || ''
      resource.image = resource.spotlight?.video || {}
    } else if (resource.__typename === ModuleNames.TEASER) {
      let bodyText = ''
      if (resource.body?.raw) {
        bodyText = documentToPlainTextString(JSON.parse(resource.body.raw))
      }

      resource.body = bodyText.slice(0, 255)
    }

    return resource
  })

  if (featuredResource?.resource) {
    if (featuredResource.resource.slug) {
      featuredResource.resource.url1 = `${location?.origin || URLS.PROD}${correctSlugPrefix(
        featuredResource.resource.slug
      )}`
    }

    let teaserBody =
      featuredResource.resource.teaserBody ||
      featuredResource.resource.seoMetadata?.pageMetaDescription

    if (featuredResource.resource.__typename === ModuleNames.TEASER) {
      const body = featuredResource.resource.body || ''
      const bodyText = documentToPlainTextString(JSON.parse(body.raw || ''))
      featuredResource.resource.body = bodyText.slice(0, 255) || ''
    } else {
      featuredResource.resource.body = teaserBody || ''
    }

    if (featuredResource.resource.__typename === ModuleNames.PAGE_RESOURCE_DEMO) {
      featuredResource.resource.image = featuredResource.resource.spotlight?.video || {}
      featuredResource.resource.title = featuredResource.resource.hero?.headline || ''
    }

    dynamicContent.unshift(featuredResource.resource)
    dynamicContent.pop()
  }

  return dynamicContent
}
